var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.73161C22 3.04406 20.435 1.7604 18.7158 2.03783L10.5107 3.36192C9.15065 3.58139 8.15385 4.72071 8.15385 6.0557V15.2965C7.51103 14.829 6.712 14.552 5.84615 14.552C3.72198 14.552 2 16.2193 2 18.276C2 20.3327 3.72198 22 5.84615 22C7.97033 22 9.69231 20.3327 9.69231 18.276V10.9625L20.4615 9.22466V13.8069C19.8187 13.3394 19.0197 13.0624 18.1538 13.0624C16.0297 13.0624 14.3077 14.7297 14.3077 16.7864C14.3077 18.8431 16.0297 20.5104 18.1538 20.5104C20.278 20.5104 22 18.8431 22 16.7864V4.73161Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.89811389337cf95b197e60800c93b163.svg";
export { ForwardRef as ReactComponent };